import React, { useState, useEffect } from "react";
import "../Styles/LogicFunctionContent.css";
import {
  Dropdown,
  DefaultButton,
  PrimaryButton,
  Dialog,
  DialogType,
  Panel,
  PanelType,
  Toggle,
  SpinButton,
  TextField
} from "@fluentui/react";
import { useBoolean } from "@fluentui/react-hooks";
import Axios from "axios";
import { toast, ToastContainer } from 'react-toastify';


const LogicFunctionContent = ({ panel }) => {
  const GenerateDeviceAddressName = (loop, address, isModule) => {
    const addr = address < 10 ? "00" + address.toString() : address < 100 ? "0" + address.toString() : address.toString();
    return isModule ? `L${GenerateTwoDigitalsNum(loop)}M${addr}` : `L${GenerateTwoDigitalsNum(loop)}D${addr}`;
  }

  const GenerateZoneAddressName = (address) => {
    const addr = address < 10 ? "00" + address.toString() : address < 100 ? "0" + address.toString() : address.toString();
    return `Z${addr}`;
  }

  const GenerateLogicFunctionName = (address) => {
    const addr = address < 10 ? "00" + address.toString() : address < 100 ? "0" + address.toString() : address.toString();
    return `Lf${addr}`;
  }

  const GenerateTwoDigitalsNum = (num) => {
    if (num < 10) {
      return "0" + num.toString();
    } else {
      return num.toString();
    }
  }

  const GenerateThreeDigitalsNum = (num) => {
    if (num < 10) {
      return "00" + num.toString();
    } else if (num < 100) {
      return "0" + num.toString();
    } else {
      return num.toString();
    }
  }

  const GenerateElementNameFromConfigFile = (operand) => {
    let elementName = "";
    let eventName = "";
    if (operand > 16777215) {
      let num = Math.floor(operand / 16777216);
      elementName = elementName + "Pn" + GenerateTwoDigitalsNum(num);
      operand %= 16777216;
    }
    if (operand > 65535) {
      let event = Math.floor(operand / 65536);
      switch (event) {
        case 1:
          eventName = "A";
          break;
        case 2:
          eventName = "P";
          break;
        case 3:
          eventName = "F";
          break;
        case 4:
          eventName = "E";
          break;
        case 5:
          eventName = "T";
          break;
        default:
          break;
      }
      operand %= 65536;
    }
    if (operand <= 2160) {
      let loopIndex = Math.floor((operand - 1) / 240);
      let deviceIndex = (operand - 1) % 240;
      if (panel.VT5000_CONFIG.ArgusTablePr[loopIndex][deviceIndex].lastTipo === 3) {
        elementName = elementName + "L" + GenerateTwoDigitalsNum(loopIndex + 1) + "M" + GenerateThreeDigitalsNum(deviceIndex + 1);
      } else {
        elementName = elementName + "L" + GenerateTwoDigitalsNum(loopIndex + 1) + "D" + GenerateThreeDigitalsNum(deviceIndex + 1);
      }
    } else if (operand >= 3841 && operand <= 3849) {
      // Need fix in the future
    } else if (operand >= 3857 && operand <= 4048) {
      elementName = elementName + "Z" + GenerateThreeDigitalsNum(operand - 3856);
    } else if (operand >= 4241 && operand <= 4432) {
      elementName = elementName + "Lf" + GenerateThreeDigitalsNum(operand - 4240);
    } else if (operand >= 4625) {
      // Need fix in the future
    } else {
      return "";
    }
    elementName = elementName + eventName;
    return elementName;
  }

  const GenerateOperandFromElementName = (name) => {
    let operand = 0;

    // Check if it starts with 'Pn'
    if (name.startsWith('Pn')) {
      const netAddress = parseInt(name.substring(2, 4)); // Two digits after Pn
      operand += netAddress * 16777216;
      name = name.substring(4); // remove PnXX
    }

    // Get Event Type at the end
    let eventCode = name.slice(-1);
    switch (eventCode) {
      case 'A':
        operand += 1 * 65536;
        name = name.slice(0, -1);
        break;
      case 'P':
        operand += 2 * 65536;
        name = name.slice(0, -1);
        break;
      case 'F':
        operand += 3 * 65536;
        name = name.slice(0, -1);
        break;
      case 'E':
        operand += 4 * 65536;
        name = name.slice(0, -1);
        break;
      case 'T':
        operand += 5 * 65536;
        name = name.slice(0, -1);
        break;
      default:
        // No event code
        break;
    }

    // Device, Zone, or Logic Function
    if (name.startsWith('L') && name[3] === 'D') {
      // Example: L01D004
      const loopIndex = parseInt(name.substring(1, 3)) - 1;
      const deviceIndex = parseInt(name.substring(4)) - 1;
      operand += 1 + loopIndex * 240 + deviceIndex;
    } else if (name.startsWith('L') && name[3] === 'M') {
      // Example: L01M013
      const loopIndex = parseInt(name.substring(1, 3)) - 1;
      const deviceIndex = parseInt(name.substring(4)) - 1;
      operand += 1 + loopIndex * 240 + deviceIndex;
    } else if (name.startsWith('Z')) {
      // Example: Z003
      const zoneIndex = parseInt(name.substring(1));
      operand += 3856 + zoneIndex;
    } else if (name.startsWith('Lf')) {
      // Example: Lf002
      const lfIndex = parseInt(name.substring(2));
      operand += 4240 + lfIndex;
    } else {
      console.error(`Unknown element format: ${name}`);
      return null;
    }

    return operand;
  }

  const GenerateElementNameFromAddress = (eventType) => {
    let netAddressString = netAddress < 10 ? "0" + netAddress.toString() : netAddress.toString();
    let elementAddress = netAddress > 0 ? "Pn" + netAddressString + elementCode + eventType : elementCode + eventType
    return elementAddress;
  }

  const getElementNameFromAddress = (code, address) => {
    let netStr = address < 10 ? "0" + address : address.toString();
    return address > 0 ? `Pn${netStr}${code}` : code;
  };

  const GenerateDetectorCodeFromAddress = (netAddress, loopIndex, deviceIndex, eventType) => {
    let event = 0;
    switch (eventType) {
      case "A":
        event = 1 * 65536;
        break;
      case "F":
        event = 3 * 65536;
        break;
      case "E":
        event = 4 * 65536;
        break;
    }
    return 1 + loopIndex * 240 + deviceIndex + netAddress * 16777216 + event;
  }

  const GenerateModuleCodeFromAddress = (netAddress, loopIndex, deviceIndex, eventType) => {
    let event = 0;
    switch (eventType) {
      case "A":
        event = 1 * 65536;
        break;
      case "P":
        event = 2 * 65536;
        break;
      case "F":
        event = 3 * 65536;
        break;
      case "E":
        event = 4 * 65536;
        break;
      case "T":
        event = 5 * 65536;
        break;
    }
    return 1 + loopIndex * 240 + deviceIndex + netAddress * 16777216 + event;
  }

  const [selectedLoop, setSelectedLoop] = useState(0);
  const [selectedDevice, setSelectedDevice] = useState(null);
  const [selectedLogicFunction, setSelectedLogicFunction] = useState(null); // Store selected device index
  const [selectedZone, setSelectedZone] = useState(null); // need delete
  const [isDevicesDialogOpen, { setTrue: openDevicesDialog, setFalse: dismissDevicesDialog }] = useBoolean(false); // need delete
  const [isZonesDialogOpen, { setTrue: openZonesDialog, setFalse: dismissZonesDialog }] = useBoolean(false);
  const [isLogicFunctionsDialogOpen, { setTrue: openLogicFunctionsDialog, setFalse: dismissLogicFunctionsDialog }] = useBoolean(false);
  const [isVTNetsDialogOpen, { setTrue: openVTNetsDialog, setFalse: dismissVTNetsDialog }] = useBoolean(false);
  const [isOutputZonesDialogOpen, { setTrue: openOutputZonesDialog, setFalse: dismissOutputZonesDialog }] = useBoolean(false);
  const [logicContent, setLogicContent] = useState(null);
  const [c1Index, setC1Index] = useState(0);
  const [c2Index, setC2Index] = useState(0);
  const [delay, setDelay] = useState(0);
  const [duration, setDuration] = useState(0);
  const [fLogicAss, setFLogicAss] = useState(0);
  const [outputZones, setOutputZones] = useState(Array(4).fill(0));
  const [logicExpression, setLogicExpression] = useState("(");
  const [logicExpressionList, setLogicExpressionList] = useState(Array(1).fill("("));
  const [isLogicFunctionDialogOpen, { setTrue: openLogicFunctionDialog, setFalse: dismissLogicFunctionDialog }] = useBoolean(false);
  const [netAddress, setNetAddress] = useState(0);
  const [elementCode, setElementCode] = useState("");
  const [isDetectorEventDialogOpen, { setTrue: openDetectorEventDialog, setFalse: dismissDetectorEventDialog }] = useBoolean(false);
  const [isModuleEventDialogOpen, { setTrue: openModuleEventDialog, setFalse: dismissModuleEventDialog }] = useBoolean(false);
  const [isZoneEventDialogOpen, { setTrue: openZoneEventDialog, setFalse: dismissZoneEventDialog }] = useBoolean(false);
  const [isShowOperand, { setTrue: showOperand, setFalse: hideOperand }] = useBoolean(true);
  const [isShowAndOrOnly, { setTrue: showAndOrOnly, setFalse: hideAndOrOnly }] = useBoolean(false);
  const [isAllSystem, setIsAllSystem] = useState(false);
  const [loop, setLoop] = useState(0);
  const [devices, setDevices] = useState(Array(0).fill(""));
  const [selectedOutputZoneIndex, setSelectedOutputZoneIndex] = useState(null);
  const [isOutputZoneSelectorDialogOpen, { setTrue: openOutputZoneSelectorDialog, setFalse: closeOutputZoneSelectorDialog }] = useBoolean(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const [level1Count, setLevel1Count] = useState(0);
  const [level2Count, setLevel2Count] = useState(0);
  const [isSensorSelected, { setTrue: selectSensor, setFalse: deselectSensor }] = useBoolean(false);

  // ------------------------------
  // Expression building helpers
  // ------------------------------
  const _isOperandToken = (token) => {
    const t = (token ?? "").trim();
    // Operands always start with a letter in this project (L.., Z.., Lf.., Pn.. etc.)
    return /^[A-Za-z]/.test(t);
  };

  const _computeCountsFromExpressionList = (list) => {
    const tokens = Array.isArray(list) ? list : [];
    const groupsClosed = tokens.filter((t) => (t ?? "").trim() === ")").length;

    // Find the last group start token "( ...", " & (", " | (", etc.
    let lastStart = -1;
    for (let i = tokens.length - 1; i >= 0; i--) {
      const t = (tokens[i] ?? "").trim();
      if (t.endsWith("(")) {
        lastStart = i;
        break;
      }
    }

    // Count operands after last "(" until the next ")"
    let operandCountCurrent = 0;
    if (lastStart >= 0) {
      for (let i = lastStart + 1; i < tokens.length; i++) {
        const t = (tokens[i] ?? "").trim();
        if (t === ")") break;
        if (_isOperandToken(t)) operandCountCurrent++;
      }
    }

    const lastTokenTrim = (tokens[tokens.length - 1] ?? "").trim();

    return { groupsClosed, operandCountCurrent, lastTokenTrim };
  };

  const _appendTokens = (tokensToAdd) => {
    setLogicExpressionList((prev) => {
      const base = Array.isArray(prev) ? [...prev] : [];
      const next = [...base, ...tokensToAdd];

      // Auto-close group when it reaches 4 operands (so user doesn't need to click ')')
      const { groupsClosed, operandCountCurrent, lastTokenTrim } = _computeCountsFromExpressionList(next);

      // If last token is an operand and the current open group already has 4 operands, close it.
      // (We only auto-close when the group is still open; i.e., last token isn't ')')
      if (groupsClosed < 4 && lastTokenTrim !== ")" && operandCountCurrent >= 4) {
        next.push(")");
      }

      // Keep the string view in sync
      setLogicExpression(next.join(""));
      return next;
    });
  };

  const addOperandToken = (token) => {
    const { groupsClosed, operandCountCurrent, lastTokenTrim } = _computeCountsFromExpressionList(logicExpressionList);

    // Max 4 groups total
    if (groupsClosed >= 4) return;

    // If current group already full/closed, user must pick And/Or to start the next group
    if (lastTokenTrim === ")" || operandCountCurrent >= 4) return;

    _appendTokens([token]);

    // After choosing an operand, show operator choices
    hideOperand();
  };

  const AddElement = (element) => {
    let newLogicExpressionList = [...logicExpressionList];
    let newLogicExpression = logicExpression + element;
    newLogicExpressionList.push(element);
    setLogicExpression(newLogicExpression);
    setLogicExpressionList(newLogicExpressionList);
  }

  const GenerateExpressionPartsFromC1Level = (c1Level) => {
    let expressionParts = [];

    for (let i = 0; i < 4; i++) {
      const group = c1Level[i];
      const { c1Operat, c2Operand, c2Operator } = group;

      if (c1Operat === 0) break;
      if (c1Operat === 6) break;

      if (i === 0) {
        expressionParts.push("(");
      } else {
        const startOp = {
          1: " & (",
          2: " | (",
          3: " ^ (",
          4: " ! (",
        }[c1Operat] || " (";
        expressionParts.push(startOp);
      }

      for (let j = 0; j < 4; j++) {
        const operand = c2Operand[j];

        if (operand > 0) {
          expressionParts.push(GenerateElementNameFromConfigFile(operand));
        }

        if (j === 3) {
          expressionParts.push(")");
        }
        else {
          const operator = c2Operator[j + 1]; // ✅ IMPORTANT: operator is at next slot

          if (operator === 1) expressionParts.push(" & ");
          else if (operator === 2) expressionParts.push(" | ");
          else if (operator === 3) expressionParts.push(" ^ ");
          else if (operator === 4) expressionParts.push(" ! ");
          else if (operator === 6) {
            expressionParts.push(")");
            break; // end of group
          }
        }
      }
    }

    return expressionParts;
  };

  useEffect(() => {
    if (selectedLogicFunction !== null) {
      const logic = panel.VT5000_CONFIG.FlogicPr?.[selectedLogicFunction];
      if (logic && logic.programmed === 1) {
        setDelay(logic.delay);
        setDuration(logic.duration);
        setFLogicAss(logic.fLogicAss);

        const updatedLogicContent = {
          c1Level: logic.c1Level.map((level) => ({
            c1Operat: level.c1Operat,
            c2Operand: [...level.c2Operand],
            c2Operator: [...level.c2Operator]
          }))
        };
        setLogicContent(updatedLogicContent);
        const expressionParts = GenerateExpressionPartsFromC1Level(logic.c1Level);

        setLogicExpression(expressionParts.join(""));
        setLogicExpressionList(expressionParts);

        showOperand();
        setOutputZones(logic.outputZones || Array(4).fill(0));
      }
      else {
        setLogicExpression("(");
        setLogicExpressionList(["("]);
        setDelay(0);
        setDuration(0);
        setFLogicAss(0);
        setOutputZones(Array(4).fill(0));
        setLogicContent({
          c1Level: [
            { c1Operat: 5, c2Operand: [0, 0, 0, 0], c2Operator: [5, 0, 0, 0] },
            { c1Operat: 0, c2Operand: [0, 0, 0, 0], c2Operator: [0, 0, 0, 0] },
            { c1Operat: 0, c2Operand: [0, 0, 0, 0], c2Operator: [0, 0, 0, 0] },
            { c1Operat: 0, c2Operand: [0, 0, 0, 0], c2Operator: [0, 0, 0, 0] }
          ]
        });
      }
    }
  }, [selectedLogicFunction, panel, refreshKey]);


  // Keep counts + UI controls in sync with the expression list.
  useEffect(() => {
    const { groupsClosed, operandCountCurrent, lastTokenTrim } = _computeCountsFromExpressionList(logicExpressionList);

    setLevel1Count(groupsClosed);

    // If last token is ')', the group is complete (4 operands max per group).
    if (lastTokenTrim === ")") {
      setLevel2Count(4);
    } else {
      setLevel2Count(operandCountCurrent);
    }

    // Disable everything after 4 groups are completed.
    if (groupsClosed >= 4) {
      hideOperand();
      // Keep the operator view hidden; buttons will still be rendered but disabled.
      hideAndOrOnly();
      return;
    }

    // Decide which controls to show based on the last token.
    const needsOperand =
      lastTokenTrim === "(" || lastTokenTrim.endsWith("(") ||
      lastTokenTrim === "&" || lastTokenTrim === "|" || lastTokenTrim === "^" || lastTokenTrim === "!" ||
      lastTokenTrim.includes("&") || lastTokenTrim.includes("|") || lastTokenTrim.includes("^") || lastTokenTrim.includes("!");

    if (lastTokenTrim === ")") {
      // After a full group, only allow And/Or to start the next group
      hideOperand();
      showAndOrOnly();
    } else if (needsOperand) {
      // Need an operand next
      hideAndOrOnly();
      showOperand();
    } else {
      // Need an operator next
      hideAndOrOnly();
      hideOperand();
    }
  }, [logicExpressionList]);


  if (!panel || Object.keys(panel).length === 0) {
    return <div>No panel data found.</div>;
  }

  const loopCardNb = panel.VT5000_CONFIG.GeneralParameters?.loopCardNb || 0;
  const loopButtonsCount = 1 + 2 * loopCardNb;

  const handleIsSelected = (loopIndex, deviceIndex) => {
    if (selectedLogicFunction === null) {
      return false;
    }
    const devices = panel.VT5000_CONFIG.OutputZones[selectedLogicFunction].devices;
    if ((loopIndex + 1 === devices[0].loop) && (deviceIndex + 1 === devices[0].address)) {
      return true;
    }
    if ((loopIndex + 1 === devices[1].loop) && (deviceIndex + 1 === devices[1].address)) {
      return true;
    }
    if ((loopIndex + 1 === devices[2].loop) && (deviceIndex + 1 === devices[2].address)) {
      return true;
    }
    if ((loopIndex + 1 === devices[3].loop) && (deviceIndex + 1 === devices[3].address)) {
      return true;
    }
    if ((loopIndex + 1 === devices[4].loop) && (deviceIndex + 1 === devices[4].address)) {
      return true;
    }
    if ((loopIndex + 1 === devices[5].loop) && (deviceIndex + 1 === devices[5].address)) {
      return true;
    }
    if ((loopIndex + 1 === devices[6].loop) && (deviceIndex + 1 === devices[6].address)) {
      return true;
    }
    if ((loopIndex + 1 === devices[7].loop) && (deviceIndex + 1 === devices[7].address)) {
      return true;
    }
  };

  const ValidateLogicExpressionList = (expressionList) => {
    let stack = [];
    let groupCount = 0;
    let operandCountInGroup = 0;
    let i = 0;

    while (i < expressionList.length) {
      const token = expressionList[i].trim();

      // Detect starting a group
      if (token.endsWith("(")) {
        stack.push("(");
        operandCountInGroup = 0;
      } else if (token === ")") {
        if (stack.length === 0) {
          console.error("Invalid: Closing ')' without matching '('");
          return false;
        }
        stack.pop();

        if (operandCountInGroup > 4) {
          console.error(`Invalid: A group has more than 4 operands (${operandCountInGroup})`);
          return false;
        }
        groupCount++;
      } else if (/^[A-Za-z]/.test(token)) {
        // Operand (starts with a letter)
        operandCountInGroup++;
      }

      i++;
    }

    if (stack.length !== 0) {
      console.error("Invalid: Unbalanced parentheses");
      return false;
    }

    if (groupCount > 4) {
      console.error(`Invalid: More than 4 groups (${groupCount})`);
      return false;
    }

    return true;
  }

  const handleLogicFunctionButtonClick = (index) => {
    showOperand();
    setSelectedLogicFunction(index);
    setRefreshKey(prev => prev + 1);
    openLogicFunctionDialog();
  }

  const handleDeviceButtonClick = (loopIndex, deviceIndex) => {
    const device = panel.VT5000_CONFIG.ArgusTablePr[loopIndex][deviceIndex];
    const isModule = netAddress > 0 ? !isSensorSelected : device.programmed === 1 && device.deviceType === 1;
    const deviceName = GenerateDeviceAddressName(loopIndex + 1, deviceIndex + 1, isModule);
    setElementCode(deviceName);
    isModule ? openModuleEventDialog() : openDetectorEventDialog();
  };

  const handleZoneButtonClick = (zoneIndex) => {
    const zoneName = GenerateZoneAddressName(zoneIndex + 1);
    setElementCode(zoneName);
    openZoneEventDialog();
  }


  const handleLFButtonClick = (logicFunctionIndex) => {
    const lFName = GenerateLogicFunctionName(logicFunctionIndex + 1);
    setElementCode(lFName);

    const elementName = getElementNameFromAddress(lFName, netAddress);
    addOperandToken(elementName);

    dismissLogicFunctionsDialog();
    setNetAddress(0);
  }

  const handleVTNETButtonClick = (vtnetIndex) => {
    setNetAddress(vtnetIndex + 1);
    dismissVTNetsDialog();
  }


  const handleDetectorAlarmButtonClick = (eventType) => {
    const elementName = GenerateElementNameFromAddress(eventType);
    addOperandToken(elementName);

    dismissDetectorEventDialog();
    dismissDevicesDialog();
    setNetAddress(0);
    // Check newLogicExpressionList



    // const code = GenerateDetectorCodeFromAddress(netAddress, selectedLoop, selectedDevice, "A");
    // setLogicContent((prev) => ({
    //   ...prev,
    //   c1Level: prev.c1Level.map((level, index) =>
    //     index === c1Index
    //       ? {
    //           ...level,
    //           c2Operand: level.c2Operand.map((op, i) =>
    //             i === c2Index ? code : op
    //           ),
    //         }
    //       : level
    //   ),
    // }));
    // // Need c1Index
    // hideOperand();
    // dismissDetectorEventDialog();
    // dismissDevicesDialog();
  };


  const handleModuleAlarmButtonClick = (eventType) => {
    const elementName = GenerateElementNameFromAddress(eventType);
    addOperandToken(elementName);

    dismissModuleEventDialog();
    dismissDevicesDialog();
    setNetAddress(0);

    // const code = GenerateDetectorCodeFromAddress(netAddress, selectedLoop, selectedDevice, "A");
    // setLogicContent((prev) => ({
    //   ...prev,
    //   c1Level: prev.c1Level.map((level, index) =>
    //     index === c1Index
    //       ? {
    //           ...level,
    //           c2Operand: level.c2Operand.map((op, i) =>
    //             i === c2Index ? code : op
    //           ),
    //         }
    //       : level
    //   ),
    // }));
    // hideOperand();
    // dismissModuleEventDialog();
    // dismissDevicesDialog();
  };


  const handleZoneEventButtonClick = (eventType) => {
    const elementName = GenerateElementNameFromAddress(eventType);
    addOperandToken(elementName);

    dismissZoneEventDialog();
    dismissZonesDialog();
    setNetAddress(0);
  };

  const handleSensorButtonClick = () => {
    selectSensor();
    openDevicesDialog();
  }

  const handleModulesButtonClick = () => {
    deselectSensor();
    openDevicesDialog();

  }

  const handleEndOperatorClick = () => {
    const { groupsClosed, lastTokenTrim } = _computeCountsFromExpressionList(logicExpressionList);
    if (groupsClosed >= 4) return;
    if (lastTokenTrim === ")") return;
    let newLogicExpressionList = [...logicExpressionList];
    let newLogicExpression = logicExpression + ")";
    newLogicExpressionList.push(")");
    setLogicExpression(newLogicExpression);
    setLogicExpressionList(newLogicExpressionList);

    // if (c2Index < 3 && c1Index < 3) {
    //   setLogicContent((prev) => ({
    //     ...prev,
    //     c1Level: prev.c1Level.map((level, index) =>
    //       index === c1Index
    //         ? { ...level, c2Operator: level.c2Operator.map((op, i) => (c2Index + 1 === i ? 6 : op)) }
    //         : level
    //     ),
    //   }));
    //   let newLogicExpressionList = [...logicExpressionList];
    //   let newLogicExpression = logicExpression + ")";
    //   newLogicExpressionList.push(")");
    //   setLogicExpression(newLogicExpression);
    //   setLogicExpressionList(newLogicExpressionList);
    //   setC1Index(c1Index + 1);
    //   setC2Index(0);
    //   // if (c1Index <= 3) {
    //   //   setLogicContent((prev) => ({
    //   //     ...prev,
    //   //     c1Level: prev.c1Level.map((level, index) =>
    //   //       index === c1Index ? { ...level, c1Operat: 5 } : level
    //   //     ),
    //   //   }));
    //   // }
    // }
  };

  const handleNotEndOperatorClick = (operator) => {
    const { groupsClosed, lastTokenTrim } = _computeCountsFromExpressionList(logicExpressionList);
    if (groupsClosed >= 4) return;
    // If we just closed a group, operator starts the next group ("& (" / "| (")
    // If we are inside a group, operator is between operands.
    let newLogicExpressionList = [...logicExpressionList];
    let newLogicExpression = logicExpression;

    const lastElement = newLogicExpressionList[newLogicExpressionList.length - 1];

    if (lastElement === ")") {
      newLogicExpression += operator + "(";
      newLogicExpressionList.push(operator + "(");
    } else {
      newLogicExpression += operator;
      newLogicExpressionList.push(operator);
    }

    setLogicExpression(newLogicExpression);
    setLogicExpressionList(newLogicExpressionList);
    showOperand();
    // if (c2Index === 0) {
    //   if (c1Index <= 3) {
    //     if (logicContent.c1Level[c1Index].c2Operator[c2Index] === 0) {
    //       setLogicContent((prev) => ({
    //         ...prev,
    //         c1Level: prev.c1Level.map((level, index) =>
    //           index === c1Index ? { ...level, c1Operat: 1 } : level
    //         ),
    //       }));
    //       let newLogicExpressionList = [...logicExpressionList];
    //       let newLogicExpression = logicExpression + " & (";
    //       newLogicExpressionList.push(" & (");
    //       setLogicExpression(newLogicExpression);
    //       setLogicExpressionList(newLogicExpressionList);
    //       setLogicContent((prev) => ({
    //         ...prev,
    //         c1Level: prev.c1Level.map((level, index) =>
    //           index === c1Index
    //             ? {
    //                 ...level,
    //                 c2Operator: level.c2Operator.map((op, i) =>
    //                   c2Index === i ? 5 : op
    //                 ),
    //               }
    //             : level
    //         ),
    //       }));
    //     } else {
    //       hideOperand(); // 👈 first
    //       setTimeout(() => {
    //         setLogicContent((prev) => ({
    //           ...prev,
    //           c1Level: prev.c1Level.map((level, index) =>
    //             index === c1Index
    //               ? {
    //                   ...level,
    //                   c2Operator: level.c2Operator.map((op, i) =>
    //                     c2Index + 1 === i ? 1 : op
    //                   ),
    //                 }
    //               : level
    //           ),
    //         }));
    //         let newLogicExpressionList = [...logicExpressionList];
    //         let newLogicExpression = logicExpression + " & ";
    //         newLogicExpressionList.push(" & ");
    //         setLogicExpression(newLogicExpression);
    //         setLogicExpressionList(newLogicExpressionList);
    //         setC2Index(c2Index + 1);
    //       }, 0); // 👈 delay state updates just one tick
    //     }
    //   }
    // } else {
    //   hideOperand();
    //   setTimeout(() => {
    //     setLogicContent((prev) => ({
    //       ...prev,
    //       c1Level: prev.c1Level.map((level, index) =>
    //         index === c1Index
    //           ? {
    //               ...level,
    //               c2Operator: level.c2Operator.map((op, i) =>
    //                 c2Index + 1 === i ? 1 : op
    //               ),
    //             }
    //           : level
    //       ),
    //     }));
    //     let newLogicExpressionList = [...logicExpressionList];
    //     let newLogicExpression = logicExpression + " & ";
    //     newLogicExpressionList.push(" & ");
    //     setLogicExpression(newLogicExpression);
    //     setLogicExpressionList(newLogicExpressionList);
    //     setC2Index(c2Index + 1);
    //   }, 0);
    // }
  };

  const onSave = () => {
    if (selectedLogicFunction >= 0 && ValidateLogicExpressionList(logicExpressionList)) {
      const parseC1LevelFromExpression = (expressionList) => {
        let c1Level = [];
        let currentGroup = null;
        let groupIndex = 0;
        let operandIndex = 0;
        let firstGroup = true; // ✅ detect first group separately

        for (let i = 0; i < expressionList.length; i++) {
          const token = expressionList[i].trim();

          if (token.endsWith("(")) {
            // Start a new group
            let operat = 5; // Default 5

            if (!firstGroup) {
              if (token.startsWith("&")) operat = 1;
              else if (token.startsWith("|")) operat = 2;
              else if (token.startsWith("^")) operat = 3;
              else if (token.startsWith("!")) operat = 4;
            }

            currentGroup = {
              c1Operat: operat,
              c2Operand: [0, 0, 0, 0],
              c2Operator: [5, 0, 0, 0] // Always start with 5
            };

            operandIndex = 0;
            firstGroup = false; // ✅ after first group
          }

          else if (/^[A-Za-z]/.test(token)) {
            if (operandIndex < 4) {
              currentGroup.c2Operand[operandIndex] = GenerateOperandFromElementName(token);
            }
          }

          else if (["&", "|", "^", "!"].includes(token.trim())) {
            const code = { "&": 1, "|": 2, "^": 3, "!": 4 }[token.trim()];
            if (operandIndex < 3) {
              currentGroup.c2Operator[operandIndex + 1] = code;
            }
            operandIndex++;
          }

          else if (token === ")") {
            const validOperandCount = currentGroup.c2Operand.filter(op => op > 0).length;

            if (validOperandCount < 4 && validOperandCount > 0) {
              currentGroup.c2Operator[validOperandCount] = 6; // insert 6 after last operand if < 4
            }

            c1Level.push(currentGroup);
            groupIndex++;
            operandIndex = 0;

            if (groupIndex >= 4) break;
          }
        }

        // ✅ Insert c1Operat = 6 at next group if fewer than 4
        if (c1Level.length < 4) {
          c1Level.push({
            c1Operat: 6,
            c2Operand: [0, 0, 0, 0],
            c2Operator: [0, 0, 0, 0]
          });
        }

        // ✅ Pad to 4 total groups
        while (c1Level.length < 4) {
          c1Level.push({
            c1Operat: 0,
            c2Operand: [0, 0, 0, 0],
            c2Operator: [0, 0, 0, 0]
          });
        }

        return c1Level;
      };

      const parsedC1Level = parseC1LevelFromExpression(logicExpressionList);
      panel.VT5000_CONFIG.FlogicPr[selectedLogicFunction].c1Level = parsedC1Level;
      panel.VT5000_CONFIG.FlogicPr[selectedLogicFunction].fLogicAss = logicExpressionList.some(item => item.includes("Lf")) ? 1 : 0;
      panel.VT5000_CONFIG.FlogicPr[selectedLogicFunction].delay = delay;
      panel.VT5000_CONFIG.FlogicPr[selectedLogicFunction].duration = duration;
      panel.VT5000_CONFIG.FlogicPr[selectedLogicFunction].programmed = 1;
      panel.VT5000_CONFIG.FlogicPr[selectedLogicFunction].outputZones = outputZones;

      const userEmail = localStorage.getItem('userEmail');
      Axios.post(`${process.env.REACT_APP_BACKEND_URL}/update_panel_flogicpr`, {
        email: userEmail,
        panelName: panel.VT5000_CONFIG.GeneralParameters.panelName,
        flogicpr: panel.VT5000_CONFIG.FlogicPr,
      })
        .then((response) => {
          if (response.data.success) {
            console.log("Logic Function updated successfully");
            dismissLogicFunctionDialog();
          } else {
            console.error("Failed to update Logic Function");
          }
        })
        .catch((error) => {
          console.error("Error updating Logic Function:", error);
        });
    } else {
      toast.error('Logic function expression is invalid!', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  };


  // const onSave = () => {
  //   if (selectedLogicFunction >= 0) {
  //     panel.VT5000_CONFIG.FlogicPr[selectedLogicFunction].delay = delay;
  //     panel.VT5000_CONFIG.FlogicPr[selectedLogicFunction].duration = duration;
  //     panel.VT5000_CONFIG.FlogicPr[selectedLogicFunction].programmed = 1;
  //     panel.VT5000_CONFIG.FlogicPr[selectedLogicFunction].outputZones = outputZones;
  //     // panel.VT5000_CONFIG.FlogicPr[selectedLogicFunction].c1Level = logicContent;
  //     console.log(logicExpression);
  //     console.log(logicExpressionList);
  //     console.log(ValidateLogicExpressionList(logicExpressionList));




  //     panel.VT5000_CONFIG.FlogicPr[selectedLogicFunction].fLogicAss = fLogicAss;

  //     // const userEmail = localStorage.getItem('userEmail');
  //     // Axios.post(`${process.env.REACT_APP_BACKEND_URL}/update_panel_flogicpr`, {
  //     //   email: userEmail,
  //     //   panelName: panel.VT5000_CONFIG.GeneralParameters.panelName,
  //     //   flogicpr: panel.VT5000_CONFIG.FlogicPr,
  //     // })
  //     //   .then((response) => {
  //     //     if (response.data.success) {
  //     //       console.log("Logic Function updated successfully");
  //     //       dismissLogicFunctionDialog();
  //     //     } else {
  //     //       console.error("Failed to update Logic Function");

  //     //     }
  //     //   })
  //     //   .catch((error) => {
  //     //     console.error("Error updating Logic Function:", error);
  //     //   });
  //   }
  // };


  const onDelete = () => {
    let newLogicExpressionList = [...logicExpressionList];
    let newLogicExpression = logicExpression;

    if (newLogicExpressionList.length < 2) {
      return; // Do nothing if only one or zero elements
    }

    const lastElement = newLogicExpressionList.pop(); // remove it from the array
    newLogicExpression = newLogicExpression.slice(0, -lastElement.length); // remove it from the string

    setLogicExpression(newLogicExpression);
    setLogicExpressionList(newLogicExpressionList);
    setNetAddress(0);
  }

  const onRemove = () => {
    if (selectedLogicFunction >= 0) {
      panel.VT5000_CONFIG.FlogicPr[selectedLogicFunction].delay = 0;
      panel.VT5000_CONFIG.FlogicPr[selectedLogicFunction].duration = 0;
      panel.VT5000_CONFIG.FlogicPr[selectedLogicFunction].fLogicAss = 0;
      panel.VT5000_CONFIG.FlogicPr[selectedLogicFunction].programmed = 0;
      panel.VT5000_CONFIG.FlogicPr[selectedLogicFunction].outputZones = Array(4).fill(0);
      panel.VT5000_CONFIG.FlogicPr[selectedLogicFunction].c1Level = [
        {
          c1Operat: 5,
          c2Operand: [0, 0, 0, 0],
          c2Operator: [5, 0, 0, 0]
        },
        {
          c1Operat: 0,
          c2Operand: [0, 0, 0, 0],
          c2Operator: [0, 0, 0, 0]
        },
        {
          c1Operat: 0,
          c2Operand: [0, 0, 0, 0],
          c2Operator: [0, 0, 0, 0]
        },
        {
          c1Operat: 0,
          c2Operand: [0, 0, 0, 0],
          c2Operator: [0, 0, 0, 0]
        }
      ];
    }

    const userEmail = localStorage.getItem('userEmail');
    Axios.post(`${process.env.REACT_APP_BACKEND_URL}/update_panel_flogicpr`, {
      email: userEmail,
      panelName: panel.VT5000_CONFIG.GeneralParameters.panelName,
      flogicpr: panel.VT5000_CONFIG.FlogicPr,
    })
      .then((response) => {
        if (response.data.success) {
          console.log("Logic Function deleted successfully");
          setLogicExpression("(");
          setLogicExpressionList(Array(1).fill("("));
          dismissLogicFunctionDialog();

        } else {
          console.error("Failed to delete Logic Function");

        }
      })
      .catch((error) => {
        console.error("Error deleting Logic Function:", error);
      });
  };

  return (
    <div className="logicFunction-content">
      {/* Logic Functions Buttons */}
      <div className="logicFunction-buttons-container">
        <div className="logicFunction-buttons-frame">
          {Array.from({ length: panel.VT5000_CONFIG.FlogicPr.length }, (_, index) => {
            const i = index; // Zone index
            const logicFunction = panel.VT5000_CONFIG.FlogicPr?.[i];
            const isProgrammed = logicFunction?.programmed === 1;

            let buttonClass = isProgrammed ? "programmed" : "not-programmed"; // Default class

            return (
              <button
                key={index}
                className={`logicFunction-button ${buttonClass}`}
                onClick={() => handleLogicFunctionButtonClick(index)}
              >
                <span>{index + 1}</span>
              </button>
            );
          })}
        </div>
      </div>

      <Dialog
        hidden={!isLogicFunctionDialogOpen}
        onDismiss={dismissLogicFunctionDialog}
        dialogContentProps={{
          type: DialogType.normal,
          title: `Logic Function ${selectedLogicFunction + 1}`
        }}
        minWidth={"1000px"}
      >
        <div>
          <div style={{ maxHeight: '300px', overflowY: 'scroll' }}>
            <TextField multiline autoAdjustHeight value={logicExpression} readOnly />
          </div>
          {isShowOperand && (<div style={{ display: 'flex', justifyContent: 'center', gap: '10px', marginTop: '20px' }}>
            {(netAddress === 0) && (<button className="select-operand-button" disabled={level1Count >= 4} onClick={() => openDevicesDialog()}>Devices</button>)}
            {(netAddress !== 0) && (<button className="select-operand-button" disabled={level1Count >= 4} onClick={() => handleSensorButtonClick()}>Sensor</button>)}
            {(netAddress !== 0) && (<button className="select-operand-button" disabled={level1Count >= 4} onClick={() => handleModulesButtonClick()}>Modules</button>)}
            <button className="select-operand-button" disabled={level1Count >= 4} onClick={() => openZonesDialog()}>Zones</button>
            {(netAddress === 0) && (<button className="select-operand-button" disabled={level1Count >= 4} onClick={() => openVTNetsDialog()}>VT-NET</button>)}
            {(netAddress === 0) && (<button className="select-operand-button" disabled={level1Count >= 4} onClick={() => openLogicFunctionsDialog()}>Logic Function</button>)}
          </div>)}
          {!isShowOperand && !isShowAndOrOnly && (<div style={{ display: 'flex', justifyContent: 'center', gap: '10px', marginTop: '20px' }}>
            <button className="select-operand-button" disabled={level1Count >= 4} onClick={() => handleEndOperatorClick()}>)</button>
            <button className="select-operand-button" disabled={level1Count >= 4} onClick={() => handleNotEndOperatorClick(" & ")}>And (&)</button>
            <button className="select-operand-button" disabled={level1Count >= 4} onClick={() => handleNotEndOperatorClick(" | ")}>Or (|)</button>
          </div>)}
          {!isShowOperand && isShowAndOrOnly && (<div style={{ display: 'flex', justifyContent: 'center', gap: '10px', marginTop: '20px' }}>
            <button className="select-operand-button" disabled={level1Count >= 4} onClick={() => handleNotEndOperatorClick(" & ")}>And (&)</button>
            <button className="select-operand-button" disabled={level1Count >= 4} onClick={() => handleNotEndOperatorClick(" | ")}>Or (|)</button>
          </div>)}
          <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "20%", margin: "20px auto 10px" }}>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", textAlign: "left" }}>
              <div style={{ display: "flex", alignItems: "center", gap: "10px", marginTop: "10px", height: "32px" }}>
                <span style={{ display: "flex", alignItems: "center", fontSize: "16px" }}>Delay:</span>
                <div style={{ display: "flex", alignItems: "center", width: "100px" }}>
                  <SpinButton
                    min={0}
                    max={255}
                    value={delay.toString()} // Ensure the value is a string
                    onChange={(event, newValue) => {
                      const parsedValue = parseInt(newValue, 10);
                      if (!isNaN(parsedValue) && parsedValue >= 0 && parsedValue <= 255) {
                        setDelay(parsedValue);
                      }
                    }}
                    styles={{
                      root: { marginBottom: "0px", padding: "0px", width: "100%" },
                      spinButtonWrapper: { height: "32px", display: "flex", alignItems: "center" },
                      input: { textAlign: "center", fontSize: "14px" },
                    }}
                  />
                </div>
              </div>
            </div>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", textAlign: "right" }}>
              <div style={{ display: "flex", alignItems: "center", gap: "10px", marginTop: "10px", height: "32px" }}>
                <span style={{ display: "flex", alignItems: "center", fontSize: "16px" }}>Duration:</span>
                <div style={{ display: "flex", alignItems: "center", width: "100px" }}>
                  <SpinButton
                    min={0}
                    max={255}
                    value={duration.toString()} // Ensure the value is a string
                    onChange={(event, newValue) => {
                      const parsedValue = parseInt(newValue, 10);
                      if (!isNaN(parsedValue) && parsedValue >= 0 && parsedValue <= 255) {
                        setDuration(parsedValue);
                      }
                    }}
                    styles={{
                      root: { marginBottom: "0px", padding: "0px", width: "100%" },
                      spinButtonWrapper: { height: "32px", display: "flex", alignItems: "center" },
                      input: { textAlign: "center", fontSize: "14px" },
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="output-zones-container-wrapper">
            <div className="output-zones-title">Output Zone Associate</div>
            <div className="output-zones-container">
              {outputZones.map((value, index) => (
                <button
                  key={index}
                  className="output-zone-button"
                  onClick={() => {
                    setSelectedOutputZoneIndex(index);
                    openOutputZoneSelectorDialog();
                  }}
                >
                  {value}
                </button>
              ))}
            </div>
          </div>
          <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px", marginTop: "20px" }}>
            <PrimaryButton text="Save" onClick={() => onSave()} />
            <DefaultButton text="Delete" onClick={() => onDelete()} />
            <DefaultButton text="Remove" onClick={() => onRemove()} />
            <DefaultButton text="Back" onClick={dismissLogicFunctionDialog} />
          </div>
        </div>
      </Dialog>

      <Dialog
        hidden={!isOutputZoneSelectorDialogOpen}
        onDismiss={closeOutputZoneSelectorDialog}
        dialogContentProps={{
          type: DialogType.normal,
          title: "Select a output zone"
        }}
        minWidth={"1200px"}
      >
        <div className="outputzone-content">
          <div className="outputzone-buttons-container">
            <div className="outputzone-buttons-frame">
              {Array.from({ length: panel.VT5000_CONFIG.OutputZones.length }, (_, index) => {
                const outputZone = panel.VT5000_CONFIG.OutputZones?.[index];
                const isProgrammed = outputZone?.programmed === 1;
                let buttonClass = isProgrammed ? "programmed" : "not-programmed";

                return (
                  <button
                    key={index}
                    className={`outputzone-button ${buttonClass}`}
                    disabled={!isProgrammed}
                    onClick={() => {
                      setOutputZones(prev => {
                        const updated = [...prev];
                        if (updated[selectedOutputZoneIndex] === index + 1) {
                          updated[selectedOutputZoneIndex] = 0; // Reset to 0 if already selected
                        }
                        else {
                          updated[selectedOutputZoneIndex] = index + 1; // 1-based index
                        }
                        return updated;
                      });
                      closeOutputZoneSelectorDialog();
                    }}
                  >
                    <span>{index + 1}</span>
                  </button>
                );
              })}
            </div>
          </div>
        </div>
      </Dialog>


      <Dialog
        hidden={!isDevicesDialogOpen}
        onDismiss={dismissDevicesDialog}
        dialogContentProps={{
          type: DialogType.normal,
        }}
        minWidth={"1000px"}
      >
        <div>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          </div>
          <div className="devices-content">
            {/* Loop Buttons */}
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "20px" }}>
              <div className="loop-buttons">
                <span>Loop:</span>
                {Array.from({ length: loopButtonsCount }, (_, index) => (
                  <button
                    key={index}
                    className={`loop-button ${selectedLoop === index ? "selected-loop" : ""}`}
                    onClick={() => setSelectedLoop(index)}
                  >
                    {index + 1}
                  </button>
                ))}
              </div>
            </div>

            {/* Device Buttons */}
            <div className="device-buttons-container">
              <div className="device-buttons-frame">
                {Array.from({ length: panel.VT5000_CONFIG.ArgusTablePr[0].length }, (_, index) => {
                  const i = selectedLoop; // Loop index
                  const j = index; // Device index
                  const device = panel.VT5000_CONFIG.ArgusTablePr?.[i]?.[j];
                  const isProgrammed = device?.programmed === 1;
                  const isModule = isProgrammed && (device.deviceType === 1) || (netAddress > 0 || !isSensorSelected);
                  const isDevice = isProgrammed && (device.deviceType === 0) || (netAddress > 0 && isSensorSelected);
                  const isSensor = netAddress > 0 && isDevice;
                  const isSmoke = (netAddress === 0) && isDevice && (device.lastTipo === 0) && (device.isMultiSensor === 0);
                  const isThermal = (netAddress === 0) && isDevice && (device.lastTipo === 1);
                  const isSmokeTherm = isDevice && (device.lastTipo === 0) && (device.isMultiSensor === 1);
                  const currentZone = panel.VT5000_CONFIG.ZoneTable[selectedZone];
                  const isDisabled =  (netAddress === 0) && !(isSmoke || isThermal || isSmokeTherm || (isModule && (device.lastTipo === 3))) || isAllSystem || loop === selectedLoop + 1 || (currentZone ? (device.zone > 0 && device.zone - 1 !== selectedZone) : false);
                  const isSelected = (isSmoke || isThermal || isSmokeTherm || (isModule && (device.lastTipo === 3))) && (isAllSystem || loop === selectedLoop + 1 || devices.includes(GenerateDeviceAddressName(i + 1, j + 1)));

                  let buttonClass = "not-programmed"; // Default class
                  if (netAddress > 0) {
                    buttonClass = isSensorSelected ? "sensor" : "module";
                  }
                  else {
                    if (isModule) {
                      buttonClass = "module";
                    }
                    else if (isSmoke) {
                      buttonClass = "smoke";
                    }
                    else if (isThermal) {
                      buttonClass = "heat";
                    }
                    else if (isSmokeTherm) {
                      buttonClass = "smokeTherm";
                    }
                  }

                  return (
                    <button
                      key={index}
                      className={`device-button ${buttonClass} ${isSelected ? "selected" : ""}`}
                      disabled={isDisabled}
                      onClick={() => { handleDeviceButtonClick(i, j); setSelectedDevice(j) }}
                    >
                      <span>{index + 1}</span>
                    </button>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </Dialog>

      <Dialog
        hidden={!isZonesDialogOpen}
        onDismiss={dismissZonesDialog}
        dialogContentProps={{
          type: DialogType.normal,
        }}
        minWidth={"1200px"}
      >
        <div>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          </div>
          <div className="zone-content">
            {/* Zones Buttons */}
            <div className="zone-buttons-container">
              <div className="zone-buttons-frame">
                {Array.from({ length: panel.VT5000_CONFIG.ZoneTable.length }, (_, index) => {
                  const i = index; // Zone index
                  const zone = panel.VT5000_CONFIG.ZoneTable?.[i];
                  const isProgrammed = zone?.programmed === 1 || netAddress > 0;

                  let buttonClass = isProgrammed ? "programmed" : "not-programmed"; // Default class

                  return (
                    <button
                      key={index}
                      disabled={!isProgrammed}
                      className={`zone-button ${buttonClass}`}
                      onClick={() => handleZoneButtonClick(index)}
                    >
                      <span>{index + 1}</span>
                    </button>
                  );


                  // return (
                  //   <button
                  //     key={index}
                  //     className={`device-button ${buttonClass} ${isSelected ? "selected" : ""}`}
                  //     disabled={isDisabled}
                  //     onClick={() => { handleDeviceButtonClick(i, j); setSelectedDevice(j) }}
                  //   >
                  //     <span>{index + 1}</span>
                  //   </button>
                  // );
                })}
              </div>
            </div>
          </div>
        </div>
      </Dialog>

      <Dialog
        hidden={!isLogicFunctionsDialogOpen}
        onDismiss={dismissLogicFunctionsDialog}
        dialogContentProps={{
          type: DialogType.normal,
        }}
        minWidth={"1200px"}
      >
        <div>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          </div>
          <div className="zone-content">
            {/* Zones Buttons */}
            <div className="zone-buttons-container">
              <div className="zone-buttons-frame">
                {Array.from({ length: panel.VT5000_CONFIG.FlogicPr.length }, (_, index) => {
                  const i = index; // Zone index
                  const logicFunction = panel.VT5000_CONFIG.FlogicPr?.[i];
                  const isProgrammed = logicFunction?.programmed === 1;

                  let buttonClass = isProgrammed ? "programmed" : "not-programmed"; // Default class

                  return (
                    <button
                      key={index}
                      disabled={!isProgrammed || index === selectedLogicFunction}
                      className={`zone-button ${buttonClass}`}
                      onClick={() => handleLFButtonClick(index)}
                    >
                      <span>{index + 1}</span>
                    </button>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </Dialog>

      <Dialog
        hidden={!isVTNetsDialogOpen}
        onDismiss={dismissVTNetsDialog}
        dialogContentProps={{
          type: DialogType.normal,
        }}
        minWidth={"1200px"}
      >
        <div>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          </div>
          <div className="zone-content">
            {/* Zones Buttons */}
            <div className="zone-buttons-container">
              <div className="zone-buttons-frame">
                {Array.from({ length: 64 }, (_, index) => {
                  const panelNumber = panel.VT5000_CONFIG.GeneralParameters.vtnetNetworkPanelNb;
                  const panelAddress = panel.VT5000_CONFIG.GeneralParameters.vtnetPanelAddress;

                  let buttonClass = index < panelNumber ? "programmed" : "not-programmed"; // Default class

                  return (
                    <button
                      key={index}
                      disabled={index >= panelNumber || index + 1 === panelAddress}
                      className={`zone-button ${buttonClass}`}
                      onClick={() => handleVTNETButtonClick(index)}
                    >
                      <span>{index + 1}</span>
                    </button>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </Dialog>

      <Dialog
        hidden={!isDetectorEventDialogOpen}
        onDismiss={dismissDetectorEventDialog}
        dialogContentProps={{
          type: DialogType.normal,
        }}
        minWidth={"1000px"}
      >
        Sensor Event
        <div style={{ display: 'flex', justifyContent: 'center', gap: '10px' }}>
          <button className="select-operand-button" onClick={() => handleDetectorAlarmButtonClick("A")}>Alarm(A)</button>
          <button className="select-operand-button" onClick={() => handleDetectorAlarmButtonClick("F")}>Fault(F)</button>
          <button className="select-operand-button" onClick={() => handleDetectorAlarmButtonClick("E")}>Exclusion(E)</button>
        </div>
      </Dialog>

      <Dialog
        hidden={!isModuleEventDialogOpen}
        onDismiss={dismissModuleEventDialog}
        dialogContentProps={{
          type: DialogType.normal,
        }}
        minWidth={"1000px"}
      >
        Module Event
        <div style={{ display: 'flex', justifyContent: 'center', gap: '10px' }}>
          <button className="select-operand-button" onClick={() => handleModuleAlarmButtonClick("A")}>Alarm(A)</button>
          <button className="select-operand-button" onClick={() => handleModuleAlarmButtonClick("P")}>Prealarm(P)</button>
          <button className="select-operand-button" onClick={() => handleModuleAlarmButtonClick("F")}>Fault(F)</button>
          <button className="select-operand-button" onClick={() => handleModuleAlarmButtonClick("E")}>Exclusion(E)</button>
          <button className="select-operand-button" onClick={() => handleModuleAlarmButtonClick("T")}>Technological(T)</button>
        </div>
      </Dialog>

      <Dialog
        hidden={!isZoneEventDialogOpen}
        onDismiss={dismissZoneEventDialog}
        dialogContentProps={{
          type: DialogType.normal,
        }}
        minWidth={"1000px"}
      >
        Zone Event
        <div style={{ display: 'flex', justifyContent: 'center', gap: '10px' }}>
          <button className="select-operand-button" onClick={() => handleZoneEventButtonClick("A")}>Alarm(A)</button>
          <button className="select-operand-button" onClick={() => handleZoneEventButtonClick("F")}>Fault(F)</button>
          <button className="select-operand-button" onClick={() => handleZoneEventButtonClick("E")}>Exclusion(E)</button>
          <button className="select-operand-button" onClick={() => handleZoneEventButtonClick("T")}>Technological(T)</button>
        </div>
      </Dialog>
    </div>
  );
};

export default LogicFunctionContent;
